import { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import App from './App';
import EventPage from './EventPage';
import OfferingPage from './OfferingPage';
import CommunityPartnerships from './CommunityPartnerships';
import PastEvents from './PastEvents';
import ForagingGuide from './ForagingGuide';
import ForagingSpeciesPage from './ForagingSpeciesPage';
import { getPageMeta } from './seo';

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView();
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

// Keeps the tab title and description in step with client-side navigation;
// the pre-rendered HTML already carries the full set of tags for each page.
function PageTitle() {
  const { pathname } = useLocation();
  useEffect(() => {
    const meta = getPageMeta(pathname);
    document.title = meta.title;
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute('content', meta.description);
  }, [pathname]);
  return null;
}

// Shared by the browser entry (index.js) and the build-time pre-renderer.
export default function AppRoutes() {
  return (
    <>
      <ScrollToTop />
      <PageTitle />
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/events/:slug" element={<EventPage />} />
        <Route path="/workshops/:slug" element={<OfferingPage />} />
        <Route path="/community-partnerships" element={<CommunityPartnerships />} />
        <Route path="/past-events" element={<PastEvents />} />
        <Route path="/foraging-guide" element={<ForagingGuide />} />
        <Route path="/foraging-guide/:slug" element={<ForagingSpeciesPage />} />
      </Routes>
    </>
  );
}
